import React from "react";
import WarrantyBanner from "./WarrantyBanner";
import HighlightSpecs from "./HighlightSpecs";
import LegalSpecifications from "../car-details/specifications/LegalSpecifications";
import * as Styles from "./Highlights.styles";

const Highlights = (): JSX.Element => {
    return (
        <Styles.Wrapper>
            <HighlightSpecs />
            <LegalSpecifications />
            <WarrantyBanner />
        </Styles.Wrapper>
    );
};

export default Highlights;
